
import './polyfills';

import 'promise-polyfill';
import 'whatwg-fetch';

import 'respimage'; // Lightweight picture and srcset polyfill
import './lazysizes-config'; // Config for lazyloader
import 'lazysizes'; // Lazyloader for media

import 'owl.carousel';

import 'semantic-ui-transition/transition';
import 'semantic-ui-dimmer/dimmer';
import 'semantic-ui-dropdown/dropdown';
import 'semantic-ui-popup/popup';
import 'nouislider';

// Isotope layout
import 'isotope-layout/dist/isotope.pkgd.js';